
import { Prop, Vue, Component, Watch } from 'vue-property-decorator';
import BaseInput from './ui/BaseInput.vue';

@Component({
    components: { BaseInput }
})
export default class PriceFilter extends Vue {
    @Prop({ default: () => ({ min: '', max: '' }) }) readonly value!: { min: string; max: string };

    min: string = this.value.min;
    max: string = this.value.max;

    @Watch('value')
    onValueChange(newValue: { min: string; max: string }): void {
        this.min = newValue.min;
        this.max = newValue.max;
    }

    emitChange(): void {
        this.$emit('input', { min: this.min, max: this.max });
    }
}
